import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { EntryMethod } from '../../common/enumerations/entry-method';

export const sellQuantityItem = async (
  quantity: number,
  lineItemData: ILineItemAddData,
): Promise<void> => {
  lineItemData.lineItem.quantity = { value: quantity, entryMethod: EntryMethod.Keyed };
  return addLineItemToTransaction(lineItemData);
};
